var LicenseStatus = /*#__PURE__*/function (LicenseStatus) {
  LicenseStatus["NotFound"] = "NotFound";
  LicenseStatus["Invalid"] = "Invalid";
  LicenseStatus["ExpiredAnnual"] = "ExpiredAnnual";
  LicenseStatus["ExpiredVersion"] = "ExpiredVersion";
  LicenseStatus["Valid"] = "Valid";
  LicenseStatus["OutOfScope"] = "OutOfScope";
  return LicenseStatus;
}(LicenseStatus || {});
export { LicenseStatus };